import React, { useEffect, useState } from 'react';

import { Text } from '@asteria/component-core/typography';

import Contenter from '@asteria/component-tools/contenter';

import { Translation } from '@asteria/language';
import { cn } from '@asteria/utils-funcs/classes';
import useConfig from '@asteria/utils-hooks/useConfig';

import './styles.scss';

const autoPlaySpeed = 3000;

const Promotion = () => {
	const content = useConfig('pages.auth.content.promotion', { deep: true });
	const total = content?.length || 0;

	const [current, setCurrent] = useState(0);
	const [isAutoPlaying, setIsAutoPlaying] = useState(true);

	useEffect(() => {
		if (total > 0 && isAutoPlaying) {
			const interval = setInterval(() => {
				setCurrent((prev) => (prev + 1) % total);
			}, autoPlaySpeed);
			return () => clearInterval(interval);
		}
	}, [total, isAutoPlaying]);

	if (total === 0) {
		return (
			<Translation
				translationKey="promotion.empty.text"
				defaultText="No slides available"
				Component={Text}
			/>
		);
	}

	const goToSlide = (index) => {
		setCurrent(index);
		setIsAutoPlaying(false);
	};

	return (
		<div
			className={cn('asteria-component__promotion-slider')}
			onMouseEnter={() => setIsAutoPlaying(false)}
			onMouseLeave={() => setIsAutoPlaying(true)}
		>
			{content.map((slide, index) => (
				<Contenter
					key={index}
					className={cn(
						'asteria-component__promotion-slider__slide',
						{
							'opacity-100': index === current,
							'opacity-0': index !== current,
						},
					)}
					content={slide.props.children}
				/>
			))}
			<div className="asteria-component__promotion-slider__dots">
				{content.map((_, index) => (
					<button
						key={index}
						className={cn(
							'asteria-component__promotion-slider__dot',
							{
								'asteria--state-active': index === current,
								'': index !== current,
							},
						)}
						onClick={() => goToSlide(index)}
						aria-label={`Go to slide ${index + 1}`}
						aria-current={index === current}
					/>
				))}
			</div>
		</div>
	);
};

Promotion.displayName = 'Promotion';

export default Promotion;
